import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Widget } from '../widget';
import { SurveyListing } from 'src/app/shared/services/buyer-api/survey.interface';
import {
  SurveyWidgetHelper,
  WidgetInfo,
} from '../widget-container/helper/survey-widget-helper';

@Component({
  selector: 'ps-widget-button',
  templateUrl: './widget-button.component.html',
  styleUrls: ['./widget-button.component.css'],
})
export class WidgetButtonComponent implements OnInit {
  @Input()
  public widget!: Widget;

  @Input()
  public active = false;

  @Input()
  public count: number = 0;

  @Input()
  public survey!: SurveyListing;

  @Output()
  public tap = new EventEmitter<Widget>();

  public widgetInfo: WidgetInfo = { image: '', type: 'standard' };

  ngOnInit() {
    this.widgetInfo = new SurveyWidgetHelper(this.survey).info();
  }

  pressed() {
    this.tap.emit(this.widget);
  }
}
